import React from "react"
import { cutLabel } from "views/atoms/text/cutLabel"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import CumulativeBarChartTemplate from "views/molecules/charts/template/CumulativeBarChartTemplate"
import { useDeltaCalculation } from "views/atoms/hooks/useDeltaCalculation"

const BrokerManufBreakdown = ({ score, subKey, title }) => {
  const { t } = useTranslation()
  const defaultTitle = t(
    `score:score.13.workplace_broker.ghg_emissions_per_brand.title`
  )
  const { label_keys, datasets, unit_key } = score?.[subKey] || {}

  const datasetCount = datasets?.[0]?.data?.length || 0
  const deltaValue = useDeltaCalculation(datasetCount)

  const getTranslatedLabel = (groupingKey) => {
    return (labelKey) => {
      if (groupingKey !== "equipment_type")
        return cutLabel(labelKey, deltaValue, deltaValue)

      return t(`common:equipment_types.${labelKey}`)
    }
  }

  const translate = (variable) => {
    if (variable === "other") {
      return t("common:equipment_types.other")
    } else if (variable === "missing") {
      return t("common:equipment_types.missing")
    }
    return variable
  }

  const datasetsFormatted = datasets.map((dataset) => ({
    label: translate(cutLabel(dataset.label_key)),
    data: dataset.data,
  }))

  return (
    <CumulativeBarChartTemplate
      title={title || defaultTitle}
      datasets={datasetsFormatted}
      labelKeys={label_keys.map(getTranslatedLabel("equipment_type"))}
      unitPath={"units:units.emission"}
      unitKey={unit_key}
      helpText={t(
        `score:score.13.workplace_broker.ghg_emissions_per_brand.help`
      )}
      hiddenLegend
      showLabelOnBar
    />
  )
}

BrokerManufBreakdown.propTypes = {
  score: PropTypes.object.isRequired,
  subKey: PropTypes.string,
  title: PropTypes.string,
}

BrokerManufBreakdown.defaultProps = {
  subKey: "ghg_emissions_per_brand_chart",
  title: null,
}

export default BrokerManufBreakdown
